module.exports = __webpack_public_path__ + "img/file-remove.e470b563.svg";